import routes from "./routes";
import DashboardService from "./Service";

export {
  routes,
  DashboardService
};

